import { ReadPapelDto } from "@/api.types"
import { FieldError, formControlClass, formSelectClass, getNestedFieldError, hasNestedFieldError } from "@/shared/components/forms/FormFieldFeedback";
import { PersonFormValues } from "@/modules/people/presentation/person.schema";
import { PersonProfilesFormMethods } from "./profile.types"
import { useFormState } from "react-hook-form";

interface UsuarioProfileProps {
  methods: PersonProfilesFormMethods
  papeis: ReadPapelDto[]
  podeVerUsuarios: boolean
}

export function UsuarioProfile({ methods, papeis, podeVerUsuarios }: UsuarioProfileProps) {
  const { errors } = useFormState<PersonFormValues>();
  const usuarioAtivo = methods.watch('usuario.ativo')
  const usuarioId = methods.watch('usuario.id')

  const existeRegistro = !!usuarioId
  const deveMostrarCampos = usuarioAtivo || existeRegistro
  const camposDesabilitados = existeRegistro && !usuarioAtivo
  const papelIdError = getNestedFieldError(errors, 'usuario.papel.id')

  if (!podeVerUsuarios) {
    return null
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="form-check" title="Ativa ou inativa a conta de usuário.">
          <input
            type="checkbox"
            className="form-check-input"
            id="usuario_ativo"
            {...methods.register("usuario.ativo")}
          />
          <label className="form-check-label" htmlFor="usuario_ativo">
            Habilitar Acesso ao Sistema
          </label>
        </div>
      </div>

      {deveMostrarCampos && (
        <div className="card-body row">
          <div className="col-md-9">
            <div className="row">
              <div className="mb-3 col-md-4">
                <label htmlFor="usuario_username" className="form-label">
                  Login:{usuarioAtivo && <span className="text-danger"> *</span>}
                </label>
                <input
                  id="usuario_username"
                  type="text"
                  className={formControlClass(!!errors.usuario?.username)}
                  disabled={camposDesabilitados}
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  {...methods.register('usuario.username')}
                />
                <FieldError message={errors.usuario?.username?.message} />
              </div>

              <div className="mb-3 col-md-4">
                <label htmlFor="usuario_senha" className="form-label">
                  Senha:{usuarioAtivo && !usuarioId && <span className="text-danger"> *</span>}
                </label>
                <input
                  id="usuario_senha"
                  type="password"
                  className={formControlClass(!!errors.usuario?.senha)}
                  disabled={camposDesabilitados}
                  autoComplete="new-password"
                  {...methods.register('usuario.senha' as any)}
                />
                <FieldError message={errors.usuario?.senha?.message} />
              </div>

              <div className="mb-3 col-md-4">
                <label htmlFor="usuario_papel" className="form-label">
                  Papel:{usuarioAtivo && <span className="text-danger"> *</span>}
                </label>
                <select
                  id="usuario_papel"
                  className={formSelectClass(hasNestedFieldError(errors, 'usuario.papel.id'))}
                  disabled={camposDesabilitados}
                  {...methods.register('usuario.papel.id')}
                >
                  {papeis.map(item => (
                    <option key={item.id} value={item.id}>{item.nome}</option>
                  ))}
                </select>
                <FieldError message={papelIdError?.message} />
              </div>

              <div className="mb-3 col-md-7">
                <label htmlFor="usuario_funcao" className="form-label">Função:</label>
                <input
                  id="usuario_funcao"
                  type="text"
                  className="form-control"
                  disabled={camposDesabilitados}
                  {...methods.register('usuario.funcao')}
                />
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <input
                    id="usuario_corfundotabela"
                    type="color"
                    disabled={camposDesabilitados}
                    {...methods.register('usuario.corfundotabela')}
                  />
                  <label htmlFor="usuario_corfundotabela" className="form-label ms-3">
                    Cor fundo tabela
                  </label>
                </div>

                <div className="mb-3">
                  <input
                    id="usuario_corletratabela"
                    type="color"
                    disabled={camposDesabilitados}
                    {...methods.register('usuario.corletratabela')}
                  />
                  <label htmlFor="usuario_corletratabela" className="form-label ms-3">
                    Cor fonte tabela
                  </label>
                </div>

                <div className="ps-3 mt-3">
                  <div className="form-check">
                    <input
                      id="usuario_recebenotificacoes"
                      type="checkbox"
                      className="form-check-input"
                      disabled={camposDesabilitados}
                      {...methods.register('usuario.recebenotificacoes')}
                    />
                    <label htmlFor="usuario_recebenotificacoes" className="form-check-label">
                      Receber Notificações de Ações
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

